import { useContext } from "react";
import arrowIcon from "../assets/images/arrow.svg";
import { LocaleContext } from "../context/LocaleContext";

export const SendResume = ({title="waiting for you in our team",action="Send resume", link="https://devsterlabs.com/apply", hint="Leave your CV and our manager will contact you soon"}) => {
  const { t } = useContext(LocaleContext);
  return (
    <div
      className="send-resume container"
      style={{ color: "#fff", minHeight: "auto" }}
    >
      <div className="row">
        <span className="row-comment">
          <img
            src={arrowIcon}
            alt="->"
            className="arrow"
            style={{ transform: "rotate(-90deg)" }}
          />
          {t(hint)}
        </span>
        <span className="heading xl-heading">
          {t(title)}
        </span>
      </div>
      <div className="row">
        <span
          onClick={() => {
            window.open(link);
          }}
          className="heading glitch xl-heading"
          style={{
            textDecoration: "underline",
            color: "#4cafc8",
            cursor: "pointer",
          }}
        >
          {t(action)}
        </span>
      </div>
    </div>
  );
};
